
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import { PrescriptionAction, PrescriptionMutation, PrescriptionState } from '@/store/Prescription/PrescriptionRoot';

// Utils
import { snakeCase } from 'lodash';

// Interfaces
import { IncludeLaborProtectionChecklist } from '@/ship/Models/Prescriptions/LaborProtection';
import Pagination from '@/ship/Models/Pagination';

// Components
import LaborProtectionChecklistsList from '@/components/Prescription/LaborProtectionChecklistsList.vue';

// Enums
import ModalEnum from '@/ship/Enums/ModalEnum';

@Component({
    components: {
        LaborProtectionChecklistsList,
    },
})
export default class LaborProtectionChecklists extends Vue {
    @PrescriptionAction GET_LABOR_PROTECTION_CHECKLISTS!: (param: {
        page: number;
        query: string;
    }) => Promise<IncludeLaborProtectionChecklist[]>;
    @PrescriptionState laborProtectionChecklists!: IncludeLaborProtectionChecklist[];
    @PrescriptionState pagination!: Pagination;
    @PrescriptionMutation RESET_LABOR_PROTECTION_CHECKLISTS!: () => void;
    @Ref() refScroll!: HTMLDivElement;
    @Ref() refSecondaryPage!: HTMLDivElement;

    isSecondaryPageOpen = false;
    isCreateChecklist = true;
    isFirstTime = false;
    selectorKey = 0;
    page = 1;
    isRequestReady = true;

    mounted() {
        this.routeType();
        window.addEventListener('wheel', this.selectWheel);
        window.addEventListener('pointerover', this.checkDevice);
    }

    beforeDestroy() {
        window.removeEventListener('wheel', this.selectWheel);
        window.removeEventListener('pointerover', this.checkDevice);
    }

    checkDevice(e: PointerEvent) {
        if (e.pointerType === 'touch') {
            this.selectWheel();
        }
    }

    /**
     * Проверка на то, сколько px осталось до конца списка
     * При достижении данного параметра произвести запрос на получение предписаний
     * Проверку осуществлять после 200 мс
     */
    selectWheel() {
        setTimeout(() => {
            const { scrollTop, scrollHeight } = this.refScroll;
            const { clientHeight } = document.documentElement;

            if (scrollTop + clientHeight >= scrollHeight - 10 && this.isRequestReady && this.pagination) {
                if (this.pagination.currentPage <= this.pagination.totalPages) {
                    this.isRequestReady = false;
                    this.urlParser().then(() => {
                        this.isRequestReady = true;
                    });
                }
            }
        }, 200);
    }

    /**
     * Convert query url from ?firstParam=param1&secondParam=param2
     * to first_param:param1;second_param:param2
     *
     * API call to load all laborProtectionChecklists
     */
    async urlParser() {
        const query = Object.entries(this.$route.query).reduce((search, [key, value]) => {
            const isKeyAllowed = /(search|createdAt|cityId|projectId|authorId|generalContractorId)/g.test(key);
            if (!isKeyAllowed) return search;

            key = key.includes('.') ? key : snakeCase(key);
            return search + `${key}:${value};`;
        }, '');

        const page = this.pagination ? this.pagination.currentPage + 1 : 1;

        await this.GET_LABOR_PROTECTION_CHECKLISTS({ page, query });
    }

    @Watch('$route', { deep: true })
    async routeType() {
        if (this.$route.name === 'labor.checklist.view') {
            this.changeToDisplayChecklist();
            this.openSecondaryPage();
            this.reloadSelectorForm();
        }

        if (this.$route.name === 'labor.checklist.create') {
            this.changeToCreateChecklist();
            this.openSecondaryPage();
            this.reloadSelectorForm();
        }

        if (this.$route.name === 'labor.checklists') {
            this.isSecondaryPageOpen = false;
            if (!Object.keys(this.$route.query).length) {
                this.RESET_LABOR_PROTECTION_CHECKLISTS();
            }
        }

        if (!this.laborProtectionChecklists) await this.urlParser();

        if (
            !this.laborProtectionChecklists?.length &&
            (this.$route.name === 'labor.checklists' || this.$route.name === 'labor.checklist.view')
        ) {
            this.$modal.show(ModalEnum.Alert, {
                title: 'По выбранным критериям чек-листов не найдено. Попробуйте применить другие фильтры.',
                actionLabel: this.$t('page.modal.answer.understand'),
            });
        }
    }

    reloadSelectorForm() {
        this.selectorKey++;
    }

    changeToDisplayChecklist() {
        this.isCreateChecklist = false;
    }

    changeToCreateChecklist() {
        this.isCreateChecklist = true;
    }

    openSecondaryPage() {
        this.isSecondaryPageOpen = true;
    }

    closeSecondaryPage() {
        this.isSecondaryPageOpen = false;
    }

    updateChecklist() {
        this.RESET_LABOR_PROTECTION_CHECKLISTS();
        this.urlParser();
    }
}
